import { TaskStatusAPI } from '@business/api/task_status';
import { TaskStatusResponse, TaskStatusId } from '@business/entities/task_status';
import { CompanyId } from '@business/entities/companies';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';

export class TaskStatusBloc extends BaseBloc {
  private readonly statusRepo = new Repository<TaskStatusResponse>({
    getItemId: item => item.id,
  });

  readonly statuses$ = this.statusRepo.items$.pipe(map(items => R.sortBy(items, 'menuOrder')));
  readonly status = R.sortBy(this.statusRepo.items, 'menuOrder');
  readonly selectTaskStatus = this.statusRepo.selectItem;

  onReset() {
    this.statusRepo.reset();
  }

  fetchTaskStatuses = () => {
    return TaskStatusAPI.fetchTaskStatuses().pipe(this.statusRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  fetchTaskStatus = (id: TaskStatusId) => {
    return TaskStatusAPI.fetchTaskStatus(id).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_general_error') }),
    );
  };

  createTaskStatus = (data: Partial<TaskStatusResponse>) => {
    return TaskStatusAPI.createTaskStatus(data).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('create_task_status'),
      }),
    );
  };

  updateTaskStatus = (id: TaskStatusId, data: Partial<TaskStatusResponse>) => {
    return TaskStatusAPI.updateTaskStatus(id, data).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_task_status'),
      }),
    );
  };

  deletTaskStatus = (id: TaskStatusId) => {
    return showDeleteConfirmation('Delete Categeory', 'Do you really want to remove this category?').pipe(
      switchMap(() => TaskStatusAPI.deletTaskStatus(id)),
      this.statusRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_task_status'),
      }),
    );
  };

  sortTaskStatus = (ids: string[]) => {
    return TaskStatusAPI.sortTaskStatus(ids).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_task_status'),
      }),
    );
  };
}
